import type {
  UpdateUserInput,
  UpdateUserUC,
  User,
  UserRepository,
} from "@phurshell/psiapp-frontend-core/domain";
import { GenericError } from "@phurshell/psiapp-frontend-core/domain";

export class UpdateUser implements UpdateUserUC {
  constructor(
    private readonly userRepo: UserRepository,
    private readonly syncSession: () => Promise<User | null>,
  ) {}

  async execute(id: number | undefined, params: Partial<UpdateUserInput>) {
    if (!id) throw new GenericError();
    await this.userRepo.updateUser(id, params);
    return this.syncSession();
  }
}
